import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import { generateKey } from '@/utils';
import {
  Section,
  SectionItem,
  SectionLabel,
  OpenSectionButton,
  Linker,
  SubCategories,
  GroupLabel,
  OpenGroupButton,
} from './MenuOuterItem.style';

class MenuOuterItem extends React.Component {
  static defaultProps = {
    isFooterMenu: false,
  };

  static propTypes = {
    locale: PropTypes.string.isRequired,
    menuItem: PropTypes.shape().isRequired,
    openGroup: PropTypes.func.isRequired,
    isFooterMenu: PropTypes.bool,
  };

  state = {
    open: false,
  };

  toggleSection = () => {
    this.setState(state => ({ open: !state.open }));
  };

  render() {
    const { open } = this.state;
    const { locale, menuItem, openGroup, isFooterMenu } = this.props;

    return (
      <Section
        key={menuItem.label}
        count={menuItem.children ? menuItem.children.length : 1}
        open={open}
        className={isFooterMenu && !menuItem.url ? 'productsMenu' : null}
      >
        <SectionItem onClick={menuItem.children ? this.toggleSection : null}>
          {/* PRODUCTS 以外の内部リンク (例) ABOUT US) */}
          {menuItem.url &&
            !menuItem.external && (
              <Link
                key={menuItem.label}
                to={`/${locale}${menuItem.url}`}
                href={`/${locale}${menuItem.url}`}
                onClick={() => {
                  if (isFooterMenu) return;
                  TagManager.dataLayer({
                    dataLayer: {
                      event: 'clickheader',
                      clickurl: `/${locale}${menuItem.url}`,
                    },
                  });
                }}
              >
                <SectionLabel underline className={isFooterMenu ? 'footerMenu' : null}>
                  {menuItem.label}
                </SectionLabel>
              </Link>
            )}
          {/* SHISEIDO GROUP へのリンク */}
          {menuItem.url &&
            menuItem.external && (
              <Linker
                href={menuItem.url}
                target="_blank"
                onClick={() => {
                  if (isFooterMenu) return;
                  TagManager.dataLayer({
                    dataLayer: {
                      event: 'clickheader',
                      clickurl: menuItem.url,
                    },
                  });
                }}
              >
                <SectionLabel underline className={isFooterMenu ? 'footerMenu' : null}>
                  {menuItem.label}
                </SectionLabel>
              </Linker>
            )}
          {/* PRODUCTS (各カテゴリ) */}
          {!menuItem.url && (
            <SectionLabel className={isFooterMenu ? 'footerMenu' : null}>{menuItem.label}</SectionLabel>
          )}
          {/* プラス/マイナス アイコン表示部分 */}
          {menuItem.children && (
            <OpenSectionButton className={open ? 'isOpened' : 'isClosed'} color={isFooterMenu ? '#fff' : '#000'} />
          )}
        </SectionItem>

        {/* PRODUCTS (各サブカテゴリ) */}
        {menuItem.children &&
          menuItem.children.map((category, index) => (
            <SubCategories
              onClick={() => openGroup(`${menuItem.label} / ${category.label}`, category)}
              key={generateKey('sub-category', index)}
            >
              <GroupLabel className={isFooterMenu ? 'footerMenu' : null}>{category.label}</GroupLabel>
              {/* 矢印アイコン表示部分 */}
              {!!(open && category.children) && <OpenGroupButton color={isFooterMenu ? '#fff' : '#000'} />}
            </SubCategories>
          ))}
      </Section>
    );
  }
}

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(MenuOuterItem);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MenuOuterItem.js